package system

import assets.*
import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.korge.view.*
import component.*

class PlayerAnimationSystem : IteratingSystem(family { all(PlayerComponent) }) {
    override fun onTickEntity(entity: Entity) {
        val stateComp = entity[StateComponent]
        val animComp = entity[SpriteAnimationComponent]
        val playerComp = entity[PlayerComponent]

        if (animComp.nextAnimation == SpriteAnimationComponent.NO_ANIMATION) {
            val animType = when (stateComp.state) {
                StateComponent.STATE_MOVING -> {
                    if (playerComp.direction == BodyDirection.RIGHT) {
                        PlayerAnimationTypes.RUN_RIGHT
                    } else {
                        PlayerAnimationTypes.RUN_LEFT
                    }
                }

                StateComponent.STATE_NORMAL -> {
                    if (playerComp.direction == BodyDirection.RIGHT) {
                        PlayerAnimationTypes.IDLE_RIGHT
                    } else {
                        PlayerAnimationTypes.IDLE_LEFT
                    }
                }

                StateComponent.STATE_FALLING -> {
                    animComp.animationType = AnimationType.STANDARD

                    if (playerComp.direction == BodyDirection.RIGHT) {
                        PlayerAnimationTypes.FALL_RIGHT
                    } else {
                        PlayerAnimationTypes.FALL_LEFT
                    }
                }

                StateComponent.STATE_JUMPING -> {
                    animComp.animationType = AnimationType.STANDARD

                    if (playerComp.direction == BodyDirection.RIGHT) {
                        PlayerAnimationTypes.JUMP_RIGHT
                    } else {
                        PlayerAnimationTypes.JUMP_LEFT
                    }
                }

                StateComponent.STATE_ON_WALL -> {
//                    animComp.animationType = AnimationType.STANDARD


                    if (playerComp.playerMetadata.playerPhysicState.isOnRightWall) {
                        PlayerAnimationTypes.WALL_JUMP_LEFT
                    } else {
                        PlayerAnimationTypes.WALL_JUMP_RIGHT
                    }
                }

                else -> PlayerAnimationTypes.IDLE_RIGHT
            }
            animComp.nextAnimation = animType.name
        }
    }
}
